import React from "react";
import { Route, Switch } from "react-router-dom";
import Certificates from "./Home";
import CertificatesCreate from "./Create";
import CertificatesClone from "./Clone";
import CertificatesUpload from "./Upload";
import CertificatesEdit from "./Edit";
import CertificatesCreateThirdParty from "./CreateThirdParty";
import LinkNotaCert from "./LinkNotaCert";
import CertificatesThirdPartyEdit from "./EditThirdParty";

function CertificatesIndex() {
  return (
    <Switch>
      <Route
        exact={true}
        path={"/certificates/new"}
        render={(props) => {
          return <CertificatesCreateThirdParty {...props} />;
        }}
      />
      <Route
        exact={true}
        path={"/certificates/link_nota_cert/:idnotacert?"}
        render={(props) => {
          return <LinkNotaCert {...props} />;
        }}
      />
      <Route
        exact={true}
        path={"/certificates/declaration/new"}
        render={(props) => {
          return <CertificatesCreate {...props} />;
        }}
      />
      <Route
        exact={true}
        path={"/certificates/declaration/upload"}
        render={(props) => {
          return <CertificatesUpload {...props} />;
        }}
      />
      <Route
        exact={true}
        path={"/certificates/declaration/clone"}
        render={(props) => {
          return <CertificatesClone {...props} />;
        }}
      />
      <Route
        exact={true}
        path={"/certificates"}
        render={(props) => {
          return <Certificates {...props} />;
        }}
      />
      <Route
        exact={true}
        path={"/certificates/declaration/existing/:keyCompany/:series/:language/:documentClass/:documentReference"}
        render={(props) => {
          props.match.params.documentClass = decodeURIComponent(props.match.params.documentClass);
          props.match.params.documentReference = decodeURIComponent(props.match.params.documentReference);
          return <CertificatesEdit {...props} />;
        }}
      />
      <Route
        exact={true}
        path={"/certificates/existing/:keyCompany/:series/:language/:documentClass/:documentReference/:idTipoDocumental/:idNotaCert"}
        render={(props) => {
          props.match.params.documentClass = decodeURIComponent(props.match.params.documentClass);
          props.match.params.documentReference = decodeURIComponent(props.match.params.documentReference);
          return <CertificatesThirdPartyEdit {...props} />;
        }}
      />
    </Switch>
  );
}

export default CertificatesIndex;
